import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';
import { ButtonBlockDark } from 'components/ui';
import linkResolver from 'utils/linkResolver';
import trimString from 'helpers/trimString';

const styles = theme => ({
  wrapper: {
    border: `1px solid ${theme.palette.background.border}`,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  text: {
    fontSize: '1rem',
    letterSpacing: '0.75px',
    marginBottom: '30px',
  },
  divider: {
    height: '1px',
    width: '60%',
    background: theme.palette.background.border,
  },
  image: {
    maxWidth: '100%',
  },
  inner: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});

function Card(props) {
  const { data, contentReference, classes } = props;
  const item = data;
  return (
    <Box className={classes.wrapper}>
      {item.image && item.image.url && (
        <Box>
          <img
            className={`${classes.image} lazyload`}
            src={`/.netlify/functions/image-proxy?url=${item.image.url}&w=2000&h=1200&fit=crop&q=10&lossless=1`}
            alt={item.image.alt}
          />
        </Box>
      )}
      <Box p={4} className={classes.inner}>
        {item.title && item.title[0] && (
          <Typography component="h6" variant="h6" align="center">
            {item.title[0].text}
          </Typography>
        )}
        <Box className={classes.divider} my={4} mx="auto" />
        {item.text && item.text[0] && (
          <Typography
            component="h6"
            variant="subtitle2"
            align="center"
            className={classes.text}
          >
            {trimString(item.text[0].text, 200)}
          </Typography>
        )}
        <Box mt="auto" display="flex" justifyContent="center">
          <ButtonBlockDark
            text="Learn more"
            link={linkResolver(contentReference ? item._meta : item.link._meta)}
          />
        </Box>
      </Box>
    </Box>
  );
}

Card.propTypes = {
  data: PropTypes.object.isRequired,
  contentReference: PropTypes.bool,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Card);
